// extracted by mini-css-extract-plugin
export default {"bottomShadow":"DeviceModal_bottomShadow__TTvPR","jsonContainer":"DeviceModal_jsonContainer__qkLNc","copyButton":"DeviceModal_copyButton__6B6KE"};